module.exports = __webpack_public_path__ + "default.aa80b810125c0d399343.jpg";